import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Toggle from '../../Button/Toggle';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { useSession } from '../../Session';
import Switch from './Switch';

const BlockDays = ({label = 'Block day', name = "blockDays", help, onChange, innerLabel, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name];
    const booleanValue = value === 1;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const { hasFeature } = useSession();

    useFieldPanelHelper(name, value, isValid);

    const handleChange = (enabled) => {
        const newValue = enabled ? 1 : null;
        updateField(name, newValue);
        onChange && onChange(newValue);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    if (!hasFeature('BLOCKED_DATES')) {
        return <Switch label="Block date"
            name="blockDate"
            help="Block date is not available on your current plan"
            disabled={true}
        />
    }

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>
        <Toggle enabled={booleanValue} onChange={handleChange} label={innerLabel ?? label} disabled={isDisabled} hideFocusRing />
    </CommonFieldWrapper>
}

export default BlockDays;
